/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to create a new document folder template.
 * @export
 * @interface CreateDocumentFolderTemplateRequest
 */
export interface CreateDocumentFolderTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentFolderTemplateRequest
     */
    name: string;
    /**
     * Parent template ID for nesting. Null for root.
     * @type {number}
     * @memberof CreateDocumentFolderTemplateRequest
     */
    parentId?: number | null;
    /**
     * Optional hex color code
     * @type {string}
     * @memberof CreateDocumentFolderTemplateRequest
     */
    color?: string | null;
}

/**
 * Check if a given object implements the CreateDocumentFolderTemplateRequest interface.
 */
export function instanceOfCreateDocumentFolderTemplateRequest(value: object): value is CreateDocumentFolderTemplateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateDocumentFolderTemplateRequestFromJSON(json: any): CreateDocumentFolderTemplateRequest {
    return CreateDocumentFolderTemplateRequestFromJSONTyped(json, false);
}

export function CreateDocumentFolderTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentFolderTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function CreateDocumentFolderTemplateRequestToJSON(json: any): CreateDocumentFolderTemplateRequest {
    return CreateDocumentFolderTemplateRequestToJSONTyped(json, false);
}

export function CreateDocumentFolderTemplateRequestToJSONTyped(value?: CreateDocumentFolderTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'parentId': value['parentId'],
        'color': value['color'],
    };
}

